export default function RectangleShape({ children, style={} }){
	return (
        <div style={{ background: '#FFF', padding: '10px', height: "100%", borderRadius: '3px', border: '1px solid #777', display:"flex", ...style}}>
            <div style={{"margin": "auto", width: "100%"}}>
                {children}
            </div>
        </div>
    )
}